var SearchService = /** @class */ (function () {
    function SearchService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Articles - Search and Filtering
     * This request will filter content based on the query params passed through. This can be used as the sitewide search. A successful response will be as follows:
   *
   * ``` json
   * {
     * "status": 200,
     * "code": "",
     * "message": "Success",
     * "data": [],
     * "dictionaries": null
     * }
     *
     * ```
     *
     * `Data` will include all the search results.
     *
     * All query parameters are optional. The types query parameter and the categories query parameter are lists/arrays, so each item needs to be passed accorind to the example.
     * @param searchQuery Optional Query with search term
     * @param types List of resource types ids. You can get these from the `Get Available Types` endpoint
     * @param categories List of resource categories ids. You can get these from the `Get Available Categories` endpoint
     * @param years Filter by years. You can get these from the `Get Available Years` endpoint
     * @param page Page number, defaults to 1
     * @param pageSize Page size, defaults to 10
     * @param pageId Id of the current epi page
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindArticlesSearchAndFiltering = function (searchQuery, types, categories, years, page, pageSize, pageId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/articles/search-and-filtering',
            query: {
                'searchQuery': searchQuery,
                'types': types,
                'categories': categories,
                'years': years,
                'page': page,
                'pageSize': pageSize,
                'pageId': pageId,
            },
        });
    };
    /**
     * Global - Autocomplete
     * This request will filter content based on the query params passed through. This can be used as the sitewide search. A successful response will be as follows:
     *
     * ``` json
     * {
       * "status": 200,
       * "code": "",
       * "message": "Success",
       * "data": [],
       * "dictionaries": null
       * }
       *
       * ```
       *
       * `Data` will include all the search results.
       *
       * All query parameters are optional. The types query parameter and the categories query parameter are lists/arrays, so each item needs to be passed accorind to the example.
     * @param searchQuery Optional Query with search term
     * @param types List of resource types ids. You can get these from the `Get Available Types` endpoint
     * @param page Page number, defaults to 1
     * @param pageSize Page Size, defaul to 10
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindGlobalSearchAndFiltering = function (searchQuery, types, page, pageSize) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/global/search-and-filtering',
            query: {
                'searchQuery': searchQuery,
                'types': types,
                'page': page,
                'pageSize': pageSize,
            },
        });
    };
    /**
     * Articles - Get Available Categories
     * This will return the following upon success:
       *
       * ``` json
       * {
         * "status": 200,
         * "code": "",
         * "message": "Success",
         * "data": [],
         * "dictionaries": null
         * }
         *
         * ```
         *
         * `Data` will include all the available categories.
     * @param pageId Id of the current epi page
     * @param types0 List of Resource type id to filter by. Optional Query Param.
     * @param types1
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindArticlesAvailableCategories = function (pageId, types0, types1) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/articles/available-categories',
            query: {
                'pageId': pageId,
                'types[0]': types0,
                'types[1]': types1,
            },
        });
    };
    /**
     * Articles - Get Available Types
     * This will return the following:
         *
         * ``` json
         * {
           * "status": 200,
           * "code": "",
           * "message": "Success",
           * "data": [],
           * "dictionaries": null
           * }
           *
           * ```
           *
           * Where `Data` will have all the available types.
     * @param pageId Id of the current epi page
     * @param categories0 List/Array of category ids used to filter types. Optional Query Parameter
     * @param categories1
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindArticlesAvailableTypes = function (pageId, categories0, categories1) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/articles/available-types',
            query: {
                'pageId': pageId,
                'categories[0]': categories0,
                'categories[1]': categories1,
            },
        });
    };
    /**
     * Global - Get Available Types
     * This will return the following:
           *
           * ``` json
           * {
             * "status": 200,
             * "code": "",
             * "message": "Success",
             * "data": [],
             * "dictionaries": null
             * }
             *
             * ```
             *
             * Where `Data` will have all the available types.
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindGlobalAvailableTypes = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/global/available-types',
        });
    };
    /**
     * Articles - Get Available Years
     * This will return the following:
             *
             * StartFragment
             *
             * ``` json
             * {
               * "status": 200,
               * "code": "",
               * "message": "Success",
               * "data": [],
               * "dictionaries": null
               * }
               * ```
               *
               * EndFragment
               *
               * Where `Data` will have all the available years.
     * @param pageId Id of the current epi page
     * @param types0 List/Array of types to filter by. This is an optional query parameter
     * @param types1 Part of the Array
     * @param categories0 List/Array of category ids used to filter. This is an optional query parameter
     * @param categories1 Part of the categories array query parameter
     * @returns any Successful response
     * @throws ApiError
     */
    SearchService.prototype.getApiV1FindArticlesAvailableYears = function (pageId, types0, types1, categories0, categories1) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/find/articles/available-years',
            query: {
                'pageId': pageId,
                'types[0]': types0,
                'types[1]': types1,
                'categories[0]': categories0,
                'categories[1]': categories1,
            },
        });
    };
    return SearchService;
}());
export { SearchService };
